import { render } from "./BloqueCuatroPrincipal.vue?vue&type=template&id=485d1637"
import script from "./BloqueCuatroPrincipal.vue?vue&type=script&lang=js"
export * from "./BloqueCuatroPrincipal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__